// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Info from '../components/General';
import {actions as GeneralAction} from '../duck';
import {actions as AuthAction} from '../../../auth/duck';
import {actions as OnBoardingAction} from '../../../on-boarding/duck';
import {actions as CurrencyAction} from '../../../currency/duck';
import {actions as CountryAction} from '../../../country/duck';
import {actions as UiAction} from '../../../ui/duck';
import {actions as CustomDomainAction} from '../../../customDomain/duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    error: state.generalConfig.error,
    currency: state.currency,
    countries: state.country.countries,
    country: state.country.country,
    fetchCountryError: state.country.fetchCountryError,
    isSaving: state.generalConfig.isSaving,
    savingSuccess: state.generalConfig.savingSuccess,
    setCurrencySuccess: state.currency.setCurrencySuccess,
    information: state.ui.storeInformation,
    isFetchingInformation: state.ui.isFetchingStoreInformation,
    storeProfileInformation: state.ui.storeProfileInformation,
    isFetchingStoreProfileInformation:
      state.ui.isFetchingStoreProfileInformation,
    contact: state.information.contact,
    isFetchingContact: state.information.isFetchingContact,
    contactTypes: state.information.contactTypes,
    socialMedia: state.information.socialMedia,
    isFetchingSocial: state.information.isFetchingSocial,
    socialMediaTypes: state.information.socialMediaTypes,
    onBoardingError: state.onBoarding.error,
    isSettingConfig: state.onBoarding.isSettingConfig,
    storeTypes: state.onBoarding.storeTypes,
    isGettingStoreTypes: state.onBoarding.isGettingStoreTypes,
    validationResult: state.onBoarding.validationResult,
    isValidating: state.onBoarding.isValidating,
    domainChangeToken: state.auth.domainChangeToken,

    isValidatingSsl: state.customDomain.isValidatingSsl,
    sslIsValid: state.customDomain.sslIsValid,
    errorValidatingSsl: state.customDomain.errorValidating,
    startGeneratingSsl: state.customDomain.startGeneratingSsl,
    isGeneratingSsl: state.customDomain.isGeneratingSsl,
    errorGeneratingSsl: state.customDomain.errorGenerating,
    customDomain: state.customDomain.customDomain,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...GeneralAction,
        ...AuthAction,
        ...OnBoardingAction,
        ...CurrencyAction,
        ...CountryAction,
        ...UiAction,
        ...CustomDomainAction,
      },
      dispatch
    )
)(Info);
